import { CtaButton, Grid, Subtitle } from '@zappyrent/hundop';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  StyledCard,
  StyledCardsWrapper,
  StyledHeading,
  StyledSection,
} from './HelpPageContent.styles';
import HelpPageContentForm from './HelpPageContentForm';

const HelpPageContent = (): JSX.Element => {
  const { t } = useTranslation('help');

  return (
    <Grid direction="column" container>
      <StyledSection>
        <StyledHeading sm="32px" md="52px" lg="50px" tag="h1">
          <span>{t('howCanWeHelpYou')}</span>
        </StyledHeading>
        <Subtitle tag="strong">{t('checkOurFAQ')}</Subtitle>
        <StyledCardsWrapper>
          <StyledCard>
            <StyledHeading sm="24px" md="24px" lg="24px" tag="h2">
              {t('areYouALandlord')}
            </StyledHeading>
            <p>{t('weAlreadyAnsweredLandlords')}</p>
            <CtaButton
              href="https://www.zappyrent.com/it/come-affittare-casa#faq"
              tag="a"
              user="landlord"
            >
              {t('landlordFAQ')}
            </CtaButton>
          </StyledCard>
          <StyledCard>
            <StyledHeading sm="24px" md="24px" lg="24px" tag="h2">
              {t('areYouATenant')}
            </StyledHeading>
            <p>{t('weAlreadyAnsweredTenants')}</p>
            <CtaButton
              href="https://zappyrent.zendesk.com/hc/it/articles/4407492167953-FAQ-e-Assistenza"
              tag="a"
              user="tenant"
            >
              {t('tenantFAQ')}
            </CtaButton>
          </StyledCard>
        </StyledCardsWrapper>
        <HelpPageContentForm />
      </StyledSection>
    </Grid>
  );
};

export default HelpPageContent;
